import React from 'react'
//import ListItem from './listItem';
//import ListItemStrategic from './listItemStrategic';
import styles from './listItemStrategicWrapper.module.scss';
import * as utils from "./../../utils/utils";


function ListItemStrategicWrapper(props) {
const {list} = props;
return (
    <div className={styles.itemWrapper}>
        
       {/*Array.isArray(list) && list.length>0 && list.map( (item, index)=>
          <ListItemStrategic key={index} item={item}/> 
        ) 
      */ } 
        {Array.isArray(list) && list.length>0 && list.map( (element, index)=>
             <span className={styles.listItem} key={index}>
                        <div className={styles.listDot} style={{ background: 'black' }}></div>
                        <div className={styles.labelName} title={`${element.name}`}>{`${utils.capitalize(element.name)}`}</div>    
             </span>) } 
    </div>
)
}

export default ListItemStrategicWrapper